import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useMetricByEnvironment } from '../discovery/metric';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useMetric = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useMetricByEnvironment({
    environmentId: validEnvironmentId,
    userId,
    uniqueId: uniqueId?.raw ?? '',
    pause: uniqueId?.resourceType !== 'metric',
  });

  const metricQuery = useMemo(() => {
    const definitionEdge = data?.environment.definition?.metrics.edges?.[0];
    return {
      fetching,
      error,
      data: { applied: undefined, definition: definitionEdge?.node },
    };
  }, [fetching, error, data]);

  return metricQuery;
};
